import { Controller } from "@hotwired/stimulus"

// Handles click-to-insert for template placeholders
// Click a placeholder in the sidebar to insert it at the cursor position in the textarea
export default class extends Controller {
  static targets = ["textarea"]

  // Track cursor position when user interacts with textarea
  cursorPosition = 0

  connect() {
    // Save cursor position on various events
    this.textareaTarget.addEventListener("click", this.saveCursorPosition.bind(this))
    this.textareaTarget.addEventListener("keyup", this.saveCursorPosition.bind(this))
    this.textareaTarget.addEventListener("select", this.saveCursorPosition.bind(this))

    // Initialize cursor position at end of content
    this.cursorPosition = this.textareaTarget.value.length
  }

  disconnect() {
    this.textareaTarget.removeEventListener("click", this.saveCursorPosition.bind(this))
    this.textareaTarget.removeEventListener("keyup", this.saveCursorPosition.bind(this))
    this.textareaTarget.removeEventListener("select", this.saveCursorPosition.bind(this))
  }

  saveCursorPosition() {
    this.cursorPosition = this.textareaTarget.selectionStart
  }

  // Called when a placeholder is clicked
  // The placeholder name is passed via data-placeholder attribute
  insert(event) {
    event.preventDefault()

    // Store reference to the button (currentTarget is only valid during event propagation)
    const button = event.currentTarget
    const placeholder = button.dataset.placeholder
    if (!placeholder) return

    const textToInsert = `{{${placeholder}}}`
    const textarea = this.textareaTarget
    const currentValue = textarea.value

    // Insert at cursor position
    const before = currentValue.substring(0, this.cursorPosition)
    const after = currentValue.substring(this.cursorPosition)

    textarea.value = before + textToInsert + after

    // Move cursor to after the inserted text
    const newPosition = this.cursorPosition + textToInsert.length
    textarea.setSelectionRange(newPosition, newPosition)
    this.cursorPosition = newPosition

    // Focus the textarea
    textarea.focus()

    // Trigger input event so Rails/Turbo knows the value changed
    textarea.dispatchEvent(new Event('input', { bubbles: true }))

    // Brief visual feedback on the clicked button
    button.classList.add('ring-2', 'ring-brand-500')
    setTimeout(() => {
      button.classList.remove('ring-2', 'ring-brand-500')
    }, 200)
  }
}
